import signs from './signs';
import nameBadges from './name-badges';
import decorDecalsStickers from './decor-decals-stickers';
import postersBannersRollUps from './posters-banners-roll-ups';
export default {
  signs,
  "name-badges": nameBadges,
  "decor-decals-stickers": decorDecalsStickers,
  "posters-banners-roll-ups": postersBannersRollUps
}


// WEBPACK FOOTER //




/** WEBPACK FOOTER **
 ** C:/Users/larss/Documents/signlabs-admin-frontend/client/app/modules/products/components/material-pricing/templates/index.js
 **/